import { render } from "./NavBar.vue?vue&type=template&id=6b3f9556"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=6b3f9556&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__